import { render, staticRenderFns } from "./IKPRNode.vue?vue&type=template&id=69b56853&scoped=true"
import script from "./IKPRNode.vue?vue&type=script&lang=js"
export * from "./IKPRNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b56853",
  null
  
)

export default component.exports